export const moduleName = `product`;

export const similarProductsSelector = (state) =>
  state[moduleName].similarProducts;

export const sizeSelector = (state) => state[moduleName].size;
export const gaSelector = (state) => state[moduleName].ga;
